<template>
  <div class id style>
    <header-vue></header-vue>
    <div class="container-l2">
      <h1 class="h11">系统消息</h1>
      <div v-show="ifHasInfo">
        <div class="znjg-box znjg-box3">
          <div class="mt30">
            <div v-for="(item,index) in sysInfo" :key="index" class="gjym-boxs relative-box">
              <h4></h4>
              <p class="relative-box">{{pagesize*(nowPage-1)+index+1}}、{{item.name}}：{{item.msg}}</p>
              <p class="p6" v-text="dateFormat2(item.time)"></p>
            </div>
          </div>
          <div class="text-right mt30">
            <el-pagination
              @current-change="handleCurrentChange"
              :page-size="pagesize"
              layout="total, prev, pager, next"
              :total="totalNum"
            ></el-pagination>
          </div>
        </div>
      </div>

      <div v-if="!ifHasInfo">
        <br />
        <br />
        <br />
        <p class="errorp">筛选后无告警消息！</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    this.$nextTick(function() {
      /*调用方法*/
      this.getSysInfo(1);
      this.getDevList();
    });
  },
  data() {
    return {
      administrators: this.getCookie("administrators"),
      sysInfo: [],
      comList: [],
      ifHasInfo: true,
      info: "",
      totalNum: 0,
      pagesize: 8,
      nowPage: 1,
      startdate: new Date(),
      enddate: new Date(),
      dialogFormVisible: false,
      company_id: this.getCookie("company_id"),
      selectAreaId: null,
      areaList: [],
      selectComId: null,
      selectCom: {},
      alarm_type: null,
      alarm_device_type: null,
      typelist: []
    };
  },
  methods: {
    handleCurrentChange(val) {
      this.nowPage = val;
      this.getSysInfo(-1);
    },
    //获取系统消息
    getSysInfo(drawlineParam) {
      var alarm_device_type;
      if (this.alarm_device_type === null) {
        alarm_device_type = -1;
      } else {
        alarm_device_type = this.alarm_device_type;
      }
      let sysInfoParams = {
        uid: this.getCookie("uid"),
        type: "系统消息",
        page: this.nowPage,
        pagesize: this.pagesize
      };
      this.sign2(sysInfoParams);
      this.$ajax
        .post(
          this.$store.state.domain + "/Home/MessageList/MessageList",
          this.$qs.stringify(sysInfoParams),
          {
            emulateJSON: true
          }
        )
        .then(res => {
          if (res.data.status == 1) {
            this.totalNum = parseInt(res.data.data.totalNumber);
            if (res.totalNum != 0) {
              this.ifHasInfo = true;
              this.sysInfo = res.data.data.messagelist;
            } else {
              this.ifHasInfo = false;
            }
          } else if (res.data.status == 10008) {
            this.delCookie("username");
            this.$router.push("/login/");
            this.$store.commit(
              "updateUserInfo",
              this.$store.state.originalUserInfo
            );
          } else {
            //console.log(res.data.msg);
          }
        });
    },
    //			点击选择公司
    clickCom() {
      //				点击公司后MAC地址设为空
      this.mac_address = "";
      //				点击公司后赋值当前选中区域为空
      this.selectAreaId = null;
      //超级管理员和普通管理员分别管理
      if (this.administrators == 3 || this.administrators == 5) {
        //点击赋值当前选中公司
        for (var i = 0; i < this.comList.length; i++) {
          if (this.comList[i].company_id == this.selectComId) {
            this.selectCom = this.comList[i];
          }
        }
      } else {
        this.selectCom.uid = this.getCookie("uid");
      }

      let valiCodeParams = {
        uid: this.selectCom.uid || -1,
        timestamp: Date.parse(new Date()),
        terminalId: 4
      };
      this.sign(valiCodeParams);
      this.$ajax
        .post(
          this.$store.state.domain + "/Home/PacketList/PacketList",
          this.$qs.stringify(valiCodeParams),
          {
            emulateJSON: true
          }
        )
        .then(res => {
          if (res.data.status == 1 && res.data.data != null) {
            this.areaList = res.data.data;
          } else if (res.data.code == 10008) {
            this.delCookie("username");
            this.$router.push("/login/");
            this.$store.commit(
              "updateUserInfo",
              this.$store.state.originalUserInfo
            );
          } else {
            //console.log(res.data.msg);
          }
        });
    },
    //			获取公司列表
    getCompanyList() {
      let valiCodeParams = {
        uid: this.getCookie("uid"),
        timestamp: Date.parse(new Date()),
        terminalId: 4,
        type: 2,
        company_id: this.getCookie("company_id"),
        page: "1",
        pagesize: "9999"
      };
      this.sign(valiCodeParams);
      this.$ajax
        .post(
          this.$store.state.domain +
            "/Home/AdministratorsList/AdministratorsList",
          this.$qs.stringify(valiCodeParams),
          {
            emulateJSON: true
          }
        )
        .then(res => {
          if ((res.data.status == 1) & (res.data.data != null)) {
            if (res.data.data.name) {
              this.comList = res.data.data.name || [];
            }
          } else if (res.data.code == 10008) {
            this.delCookie("username");
            this.$router.push("/login/");
            this.$store.commit(
              "updateUserInfo",
              this.$store.state.originalUserInfo
            );
          } else {
            //console.log(res.data.msg);
          }
        });
    },
    //			获取设备类别列表
    getDevList() {
      let valiCodeParams = {
        uid: this.getCookie("uid"),
        token: this.getCookie("token"),
        time: Date.parse(new Date()),
        terminalId: 4
      };
      this.sign2(valiCodeParams);
      this.$ajax
        .post(
          this.$store.state.domain2 + "/admin/AlarmCount/AlarmDevice",
          this.$qs.stringify(valiCodeParams),
          {
            emulateJSON: true
          }
        )
        .then(res => {
          if ((res.data.code == 200) & (res.data.data != null)) {
            this.typelist = res.data.data;
          } else if (res.data.code == 10008) {
            this.delCookie("username");
            this.$router.push("/login/");
            this.$store.commit(
              "updateUserInfo",
              this.$store.state.originalUserInfo
            );
          } else {
            //console.log(res.data.msg);
          }
        });
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/systemMsg.vue